var toText = vis => {
  if (vis && vis.duration && vis.duration > 0 && vis.unit) {
    if (vis.duration > 1) {
      return "".concat(vis.duration, " ").concat(vis.unit, "s");
    }
    return vis.unit;
  }
  return null;
};
export default {
  toText
};